const download = (path) => {
  const a = document.createElement('a')
  a.href = window.location.origin + path
  a.download = path.split('/').pop()
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export default download
